import type { FC, SVGProps } from "react";
import React from "react";

const FestivalAllCategory: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="festival category icon">
      {/* <title>festival category icon</title> */}
      <g>
        <path
          d="M13.128,16.305V34.166a1.943,1.943,0,0,0,1.942,1.942H22.8l-.96,1.978a1.944,1.944,0,0,1-2.6.9L3.828,31.5a1.939,1.939,0,0,1-.9-2.6l8.451-17.4A10.511,10.511,0,0,1,25.427,6.638a10.135,10.135,0,0,1,.934.516,9.782,9.782,0,0,0-13.233,9.151Z"
          fill="#ffc267"
        />
        <path
          d="M30.743,36.562H15.071a2.4,2.4,0,0,1-2.4-2.4V16.3a10.233,10.233,0,0,1,20.466,0V26.767a.455.455,0,1,1-.909,0V16.3a9.324,9.324,0,0,0-18.648,0V34.165a1.489,1.489,0,0,0,1.488,1.488H30.743a1.49,1.49,0,0,0,1.488-1.488v-4.8a.455.455,0,0,1,.909,0v4.8A2.4,2.4,0,0,1,30.743,36.562Z"
          fill="#0d365c"
        />
        <path
          d="M22.907,14.838a2.468,2.468,0,1,1,2.468-2.467A2.47,2.47,0,0,1,22.907,14.838Zm0-4.027a1.56,1.56,0,1,0,1.559,1.56A1.561,1.561,0,0,0,22.907,10.811Z"
          fill="#0d365c"
        />
        <path
          d="M22.907,10.811a.454.454,0,0,1-.454-.454V2.875a.454.454,0,0,1,.908,0v7.482A.454.454,0,0,1,22.907,10.811Z"
          fill="#0d365c"
        />
        <path
          d="M27.8,32.35H17.244a.454.454,0,0,1,0-.908H27.8a.454.454,0,0,1,0,.908Z"
          fill="#0d365c"
        />
        <path
          d="M27.8,30.092H17.244a.455.455,0,0,1,0-.909H27.8a.455.455,0,0,1,0,.909Z"
          fill="#0d365c"
        />
        <path
          d="M19.93,24.8a.454.454,0,0,1-.322-.775l5.956-5.955a.454.454,0,0,1,.642.642l-5.955,5.955A.452.452,0,0,1,19.93,24.8Z"
          fill="#0d365c"
        />
        <path
          d="M25.441,24.8a.9.9,0,1,1,.9-.9A.9.9,0,0,1,25.441,24.8Z"
          fill="#0d365c"
        />
        <path
          d="M20.373,19.625a.9.9,0,1,1,.9-.9A.9.9,0,0,1,20.373,19.625Z"
          fill="#0d365c"
        />
      </g>
    </svg>
  );
};

export default FestivalAllCategory;
